import { Component } from '@angular/core';
import { FlowManagerService } from '../../shared/services/flowmanager.service';
import { ModalService } from '../../shared/services/modal.service';

@Component({
  selector: 'ns-questionnaire-right-rail',
  template: require('./questionnaire-right-rail.component.html'),
  styles: [require('./questionnaire-right-rail.component.scss')]
})
export class QuestionnaireRightRailComponent {
  whyWeAsk;

  constructor(
    flowManager: FlowManagerService,
    modal: ModalService) {
    this.modal = modal;
    this.flowManager = flowManager;
    this.whyWeAsk = flowManager.whyWeAsk;
    this.flowManagerSubscription = flowManager.whyWeAskCopyChange.subscribe(event => {
      this.whyWeAsk = event;
    });
  }

  ngOnDestroy() {
    this.flowManagerSubscription.unsubscribe();
  }

  openModal() {
    this.modal.generic(this.whyWeAsk.modalContent);
  }

}
